import { useEffect, useState } from 'react';
import { useRecoilValue } from 'recoil';
import dayjs from 'dayjs';
import { TransIdState } from 'src/recoil/join';

export const useTimer = (delayResend: number) => {
  const transId = useRecoilValue(TransIdState);
  const [delay, setDelay] = useState(+delayResend);

  useEffect(() => {
    setDelay(+delayResend);

    if (delayResend <= 0) return;

    const timer = setInterval(() => {
      setDelay((prev) => (prev <= 0 ? 0 : prev - 1));
    }, 1000);

    return () => clearInterval(timer);
  }, [delayResend, transId]);

  const minutes = Math.floor(delay / 60);
  const seconds = Math.floor(delay % 60);
  const formatTime = dayjs().minute(minutes).second(seconds).format('mm:ss');

  return { formatTime, delay };
};
